import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSEOData } from '../data/seoData';

const PAGE_TITLES = {
  '/': 'Prime Markets - Premium Trading Platform',
  '/forex': 'Forex | Prime Markets',
  '/stocks': 'Stocks | Prime Markets',
  '/indices': 'Indices | Prime Markets',
  '/commodities': 'Commodities | Prime Markets',
  '/crypto': 'Crypto | Prime Markets',
  '/primemarketx': 'PrimeMarketX | Prime Markets',
  '/primemarket': 'PrimeMarket Platform | Prime Markets',
  '/accounts': 'Accounts | Prime Markets',
  '/account-types': 'Account Types | Prime Markets',
  '/about-prime-markets': 'About Prime Markets',
  '/reviews': 'Reviews | Prime Markets',
  '/news': 'News | Prime Markets',
  '/funding-and-withdrawals': 'Funding and Withdrawals | Prime Markets',
  '/personal-support-managers': 'Personal Support Managers | Prime Markets',
  '/faqs': 'FAQs | Prime Markets',
  '/economic-calendar': 'Economic Calendar | Prime Markets',
  '/verification': 'Verification | Prime Markets',
  '/cfd-trading': 'CFD Trading | Prime Markets',
  '/cfd-trading/our-changes': 'Trading Charges | Prime Markets',
  '/trade-insider': 'Trade Insider | Prime Markets',
  '/mobile-app': 'Mobile App | Prime Markets',
  '/get-started': 'Get Started | Prime Markets'
};

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Try to get SEO data first, fallback to PAGE_TITLES
    const seoData = getSEOData(location.pathname);
    const title = seoData.title || PAGE_TITLES[location.pathname] || 'Prime Markets';
    document.title = title.includes('Prime Markets') ? title : `${title} | Prime Markets`;
  }, [location.pathname]);

  // Return SEO data for the current route (useful for components that need it)
  return getSEOData(location.pathname);
};

export default usePageTitle;